export const SectionAboutUsTranslationsEn = {
  'About Us': 'About Us',
  'AniraK...':
    "AniraKids rents occasion dresses and suits for children and adults. Choose an outfit from our catalogue for a celebration, wedding or family photoshoot.",
};
